import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import "../../Localization/i18n";
import Users_Roles from './Users&Roles/Users_Roles';
import CompaniesTab from './Companies/CompaniesTab';
import EmailTemplatesTab from './Email/EmailTemplatesTab';
import NotificationsAndInvitationsTab from './Notifications-Invitations/NotificationsAndInvitationsTab';
import FeaturesTab from './Features/FeaturesTab';
import DocumentTypes from './DocumentTypes/DocumentTypes';
import InstructionBanner from './InstructionBanner/InstructionBanner';
import PowerBIPermissions from './PowerBIPermissions/PowerBIPermissions';
import ContractorEvaluations from './ContractorEvaluations/ContractorEvaluations';
import Departments from './Departments/Departments';
import { useLocation } from 'react-router-dom';
import { useGlobalComponent } from '../../pages/commom/GlobalComponentProvider';
import { HasScreenPermissions } from '../../utils/Token';
// import INFO from "../../utils/Enums.json";
import INFO from '../../pages/commom/RouteUrlInfo.json';
import { getOrgType } from "../../utils/Token";
import CourseInstructions from './CourseInstructions/CourseInstructions';
import Uploadpreloginimages from './Uploadimages/Uploadpreloginimages';
import SubscriptionFee from './SubscriptionFee/SubscriptionFee';

function TabPanel(props) {

    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function SettingsTab() {
    const { currentActiveTab, currentActiveSubTab } = useGlobalComponent();
    const [value, setValue] = useState(0); // Initialize with the default tab index
    const { t } = useTranslation();
    const location = useLocation();




    useEffect(() => {
        setValue(currentActiveTab);
    }, [currentActiveTab, location]);

    const [MoveValue, setMOveValue] = useState(false);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (getOrgType() != "Admin") {
            setMOveValue(true);
        }
    };
    // console.log(INFO);
    return (

        <>
            <div style={{ minwidth: "100%", backgroundColor: "#F9FAFB" }} hidden={getOrgType() == "Vendor"}>
                <h1 className='mx-3 mt-3' style={{ color: 'rgb(0,0,0)' }} >Settings</h1>
            </div>
            <Tabs value={value} onChange={handleChange} variant="scrollable" sx={{ marginLeft: 3 }}>
                {/* <Tab label={t("Settings.users")} {...a11yProps(0)} hidden={HasMainPermissions('ScreenName',1)} style={{ textTransform: "inherit" }} /> */}
                <Tab label={!HasScreenPermissions(INFO?.AddSystemRole?.actionName) ? t("Settings.users") : t("Users.users")} {...a11yProps(0)} hidden={getOrgType() == "Client" ? HasScreenPermissions(INFO?.ClientOrVendorUsersList?.actionName) : HasScreenPermissions(INFO?.SearchUser?.actionName) || getOrgType() == "Vendor"} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.companies")} {...a11yProps(1)} hidden={HasScreenPermissions(INFO?.SearchCompany?.actionName) && HasScreenPermissions(INFO?.ManageSites?.actionName)} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.email")} {...a11yProps(2)} hidden={HasScreenPermissions(INFO?.EmailTemplatesList?.actionName) && HasScreenPermissions(INFO?.EmailVendor?.actionName)} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.notifications")} {...a11yProps(3)}
                    hidden={HasScreenPermissions(INFO?.ManageNotifications?.actionName) && HasScreenPermissions(INFO?.ManageInvitationNotifications?.actionName) && HasScreenPermissions(INFO?.AddInvitationTemplates?.actionName) && HasScreenPermissions(INFO?.AddInviteNotifications?.actionName) && HasScreenPermissions(INFO?.CronjobNotificationSetup?.actionName) && HasScreenPermissions(INFO?.NotificationsSetup?.actionName)} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.features")} {...a11yProps(4)} hidden={HasScreenPermissions(INFO?.BiddingInterestsList?.actionName) && HasScreenPermissions(INFO?.ProficiencyCapabilitiesList?.actionName)} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.documenttypes")} {...a11yProps(5)} hidden={HasScreenPermissions(INFO?.DocumentTypesList?.actionName)} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.instructionBanner")} {...a11yProps(6)} hidden={HasScreenPermissions(INFO?.InstructionBanner?.actionName)} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.contractorevaluations")} {...a11yProps(7)} hidden={HasScreenPermissions(INFO?.MyContractorEvaluations?.actionName)} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.PowerBIPermissions")} {...a11yProps(8)} hidden={HasScreenPermissions(INFO?.AddPowerBiPermissions?.actionName)} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.Departments")} {...a11yProps(9)} hidden={HasScreenPermissions(INFO?.AddDepartments?.actionName)} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.CourseInstructions")} {...a11yProps(10)} hidden={HasScreenPermissions(INFO?.CourseInstructions?.actionName)} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.Uploadimages")} {...a11yProps(11)} hidden={HasScreenPermissions(INFO?.UploadImages?.actionName)} style={{ textTransform: "inherit" }} />
                <Tab label={t("Settings.SubscriptionFee")} {...a11yProps(12)} hidden={HasScreenPermissions(INFO?.SubscriptionFee?.actionName)} style={{ textTransform: "inherit" }} />
            </Tabs>
            <TabPanel value={value} index={0} >
                <Users_Roles MOveValue={MoveValue} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <CompaniesTab MOveValue={MoveValue} />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <EmailTemplatesTab MOveValue={MoveValue} />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <NotificationsAndInvitationsTab MOveValue={MoveValue} />
            </TabPanel>
            <TabPanel value={value} index={4}>
                <FeaturesTab val={value} MOveValue={MoveValue} />
            </TabPanel>
            <TabPanel value={value} index={5}>
                <DocumentTypes />
            </TabPanel>
            <TabPanel value={value} index={6}>
                <InstructionBanner />
            </TabPanel>
            <TabPanel value={value} index={7}>
                <ContractorEvaluations />
            </TabPanel>
            <TabPanel value={value} index={8}>
                <PowerBIPermissions />
            </TabPanel>
            <TabPanel value={value} index={9} hidden={HasScreenPermissions(INFO?.AddDepartments?.actionName)}>
                <Departments />
            </TabPanel>
            <TabPanel value={value} index={10}>
                <CourseInstructions />
            </TabPanel>
            <TabPanel value={value} index={11}>
                <Uploadpreloginimages />
            </TabPanel>
            <TabPanel value={value} index={12}>
                <SubscriptionFee />
            </TabPanel>
        </>
    );
}
